module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "autoplay": false,
      "with-carousel-list": "",
      "indicator": false,
      "overlay": _vm.gallery
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function(props) {
        return [_c('b-carousel-list', {
          attrs: {
            "data": _vm.items,
            "config": _vm.al,
            "refresh": _vm.gallery,
            "as-indicator": ""
          },
          on: {
            "switch": function($event) {
              props.switch($event, false)
            }
          },
          model: {
            value: (props.active),
            callback: function($$v) {
              _vm.$set(props, "active", $$v)
            },
            expression: "props.active"
          }
        })]
      }
    }])
  }, [_vm._l((_vm.items), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('figure', {
      staticClass: "image",
      on: {
        "click": function($event) {
          _vm.switchGallery(true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.image
      }
    })])])
  }), _vm._v(" "), (_vm.gallery) ? _c('span', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.switchGallery(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "overlay"
  }, [_c('div', {
    staticClass: "has-text-centered has-text-white"
  }, [_vm._v("\n                Hello i'am overlay!\n            ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a65b20"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExWithList.vue
// module id = 1001
// module chunks = 3 160